module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTPro-Roman.e1e0288.ttf";